import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column',
    boxShadow: theme.shadow.medium,
    [theme.breakpoints.up('md')]: {
      padding: `${rem(3)} ${rem(4)}`,
      flexFlow: 'row',
    },
  },
  divider: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      margin: `${rem(7)} ${rem(10)}`,
      height: rem(44),
      width: 'inherit',
    },
  },
  button: {
    padding: rem(4),
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: `0 ${rem(4)}`,
      width: 'inherit',
      display: 'flex',
    },
  },
}));
